import React from 'react';
import './StarRating.scss';

/**
 * Star rating. Read-only by default; pass `onChange` to make it an
 * accessible radio group for review submission.
 */
const StarRating = ({ value = 0, max = 5, onChange, name = 'rating', size = 'md' }) => {
  const rounded = Math.round(Number(value) || 0);

  if (!onChange) {
    return (
      <span
        className={`star-rating star-rating--${size}`}
        role="img"
        aria-label={rounded ? `Rated ${rounded} out of ${max}` : 'Not yet rated'}
      >
        {Array.from({ length: max }).map((_, index) => (
          <span key={index} className={index < rounded ? 'is-filled' : ''} aria-hidden="true">
            ★
          </span>
        ))}
      </span>
    );
  }

  return (
    <fieldset className={`star-rating star-rating--interactive star-rating--${size}`}>
      <legend className="visually-hidden">Rating</legend>
      {Array.from({ length: max }).map((_, index) => {
        const starValue = index + 1;
        return (
          <label key={starValue} className={starValue <= rounded ? 'is-filled' : ''}>
            <input
              type="radio"
              name={name}
              value={starValue}
              checked={starValue === rounded}
              onChange={() => onChange(starValue)}
              className="visually-hidden"
            />
            <span aria-hidden="true">★</span>
            <span className="visually-hidden">
              {starValue} star{starValue > 1 ? 's' : ''}
            </span>
          </label>
        );
      })}
    </fieldset>
  );
};

export default StarRating;
